// extracted by mini-css-extract-plugin
export default {"container":"Dashboard_container__Db7EQ","content":"Dashboard_content__fxgHO","heading":"Dashboard_heading__FS9GJ","grid":"Dashboard_grid__Dks7T"};